export const smallScreenWidth = 700